var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcnMailLetter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 1 12 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6758 3.17578V2L6 4.92578L1.32422 2V3.17578L6 6.07422L10.6758 3.17578ZM10.6758 0.824219C10.9857 0.824219 11.25 0.942708 11.4688 1.17969C11.7057 1.41667 11.8242 1.6901 11.8242 2V9C11.8242 9.3099 11.7057 9.58333 11.4688 9.82031C11.25 10.0573 10.9857 10.1758 10.6758 10.1758H1.32422C1.01432 10.1758 0.740885 10.0573 0.503906 9.82031C0.285156 9.58333 0.175781 9.3099 0.175781 9V2C0.175781 1.6901 0.285156 1.41667 0.503906 1.17969C0.740885 0.942708 1.01432 0.824219 1.32422 0.824219H10.6758Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnMailLetter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-mail-letter.7baee8ba.svg";
export { ForwardRef as ReactComponent };